import {Injectable} from '@angular/core';
import {PressUserService} from './state/service';
import {PressUserQuery} from './state/query';
import {FilterService as BaseService} from '../../components/filter.service';
import {PressUser} from './state/model';
import {PressUserState, Store} from './state/store';


@Injectable({providedIn: 'root'})
export class FilterService extends BaseService<PressUser, PressUserState, PressUserQuery, Store> {
  constructor(protected query: PressUserQuery, protected api: PressUserService) {
    super(query, api);
  }
}
